export enum ApplicationRoutes {
  HOME = '/',
  LOGIN = '/login',
  SELECT_PBX = '/select-pbx',
  SECURE_FAX = '/secure-fax/:token',
  SECURE_FAX_LEGACY = '/virtualfax/securefax/:token',
  CALLS = '/calls',
  MISSED_CALLS = '/missed-calls',
  MESSAGING = '/messaging',
  VOICEMAIL = '/voicemails',
  FAX = '/faxes',
  CONTACTS = '/contacts',
  CALL_ANALYTICS = '/analytics',
  WEB_PHONE = '/web-phone',
  SETTINGS = '/settings',
  ICONS = '/icons',
  DASHBOARDS = '/dashboards',
  REPORTING = '/reporting',

  // App status panel routes
  STATUS = '/status',
  STATUS_ADVANCED = '/status/advanced',

  // Admin panel routes
  ADMIN = '/admin',
  USERS = '/admin/users',
  USER_DETAIL = '/admin/users/:userId',
  INTEGRATIONS = '/admin/integrations',
  INTEGRATION_DETAIL = '/admin/integrations/:integrationId',
  HOTELS = '/hotels',
  HOTELS_SETTINGS = '/hotels/settings',
  HOTELS_WAKEUP = '/hotels/wakeup',
  HOTELS_WAKEUP_HISTORY = '/hotels/wakeup-history',
  SWITCHBOARDS = '/admin/switchboards',
  SWITCHBOARD_EDIT = '/admin/switchboards/:extensionDialPlan',
  MESSAGING_GROUPS = '/admin/messaging-groups',
  MESSAGING_GROUP_DETAIL = '/admin/messaging-groups/:groupId',
  DEVICES = '/admin/devices',
  DEVICE_NEW = '/admin/devices/new',
  DEVICE_EDIT = '/admin/devices/:deviceId',
  EXTENSIONS = '/admin/extensions',
  EXTENSION_EDIT = '/admin/extensions/:type/:extensionId',
  USER_GROUPS = '/admin/user-groups',
  USER_GROUP_ADD = '/admin/user-groups/add',
  USER_GROUP_EDIT = '/admin/user-groups/:userGroupId/edit',
  API_ACCESS = '/admin/api-access',
  SCHEDULES = '/admin/schedules',
  FORGOT_PASSWORD = '/forgot-password',
  RESET_PASSWORD = '/reset-password/:uidb64/:token',
  OPEN_APP = '/open',
  OPENED_IN_DESKTOP = '/opened-in-desktop',
}
